import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuRadioButtonGroupProps } from '../WbuRadioButtonGroup.props';

export const props = withCompInfo<IWbuRadioButtonGroupProps, any>()(
  ['compData'],
  ({ compData }) => ({
    ...compData,
  }),
);

export default createComponentMapperModel({
  props,
});
